var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C16.4183 22 20 18.8859 20 13.8108C20 8.73576 16.5 2 12 2C7.5 2 4 8.73576 4 13.8108C4 18.8859 7.58172 22 12 22ZM17.7091 15.2442C16.9382 17.4833 15.2922 19.0556 13.228 19.7145C12.8334 19.8404 12.4115 19.6227 12.2855 19.228C12.1596 18.8334 12.3773 18.4115 12.772 18.2855C14.3757 17.7736 15.671 16.5563 16.2909 14.7558C16.4257 14.3642 16.8525 14.156 17.2442 14.2909C17.6358 14.4257 17.844 14.8525 17.7091 15.2442Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.74cee20e7856503e61c645ee60f496d1.svg";
export { ForwardRef as ReactComponent };